jQuery(document).ready(function ($) {

    $('#avatar').change(function () {
        let img = $(this).val();
        img = img.split("\\");
        $('#upload-avatar').find('span').html(img[img.length - 1]);
    });
    
    $('#upload-avatar').click(function () {
        $('#avatar').click();
    });

});